import './dialog-message.scss';

/*
 * Handles the display of errors, prompts, and information dialogs
 */
angular.module('v6CoreModule').directive('dialogMessage', ($rootScope) => {
  let linkFn;

  linkFn = (scope, element, attrs) => {
    function forceDigest() {
      if (!$rootScope.$$phase) {
        //$digest or $apply
        $rootScope.$digest();
      }
    }

    let errorBox, mask, masks, animateDown, dialogMessage, messages;
    messages = angular.element(element.children()[0]);
    masks = angular.element(element.children()[1]);
    const templateBox = angular.element(element.children()[2]);
    const templateMask = angular.element(element.children()[3]);

    // TODO refactor this JQey stuff
    scope.$on('displayMessage', (l, guid) => {
      const body = '';
      const maskHeight = $(window).height();
      const maskWidth = $(window).width();
      const dialogMessage = scope.dialogMessage[guid],
        dialogType = dialogMessage.type,
        callback = dialogMessage.callback,
        hideDelay = dialogMessage.time ? dialogMessage.time : 1000;

      //Make a clone so multiple errors can be displayed
      const errorBox = $(templateBox).clone();
      $(errorBox).appendTo(messages);
      const mask = $(templateMask).clone();
      $(mask).appendTo(masks);

      $(errorBox).attr('class', dialogType);

      $(mask).css({
        width: '100vw',
        height: '100vh',
      });
      $(mask).fadeTo('slow', 0.6);

      if (dialogType == 'prompt' || dialogType == 'errorprompt') {
        //Include HTML first so we can bind click functions to the buttons
        $(errorBox).html(dialogMessage.message).trigger('create');

        $(errorBox)
          .find('#YesButton')
          .click(() => {
            $(errorBox).fadeTo('fast', 0.0, () => {
              if (callback) {
                callback('yes');
                forceDigest();
              }
              delete scope.dialogMessage[guid];
              $(mask).fadeTo('fast', 0.0).remove();
              $(errorBox).remove();
            });
          });
        $(errorBox)
          .find('#NoButton')
          .click(() => {
            $(errorBox).fadeTo('fast', 0.0, () => {
              if (callback) {
                callback('no');
                forceDigest();
              }
              delete scope.dialogMessage[guid];
              $(mask).fadeTo('fast', 0.0).remove();
              $(errorBox).remove();
            });
          });
        $(errorBox)
          .find('#OkButton')
          .click(() => {
            $(errorBox).fadeTo('fast', 0.0, () => {
              if (callback) {
                callback('ok');
                forceDigest();
              }
              delete scope.dialogMessage[guid];
              $(mask).fadeTo('fast', 0.0).remove();
              $(errorBox).remove();
            });
          });
        $(errorBox)
          .find('#CancelButton')
          .click(() => {
            $(errorBox).fadeTo('fast', 0.0, () => {
              if (callback) {
                callback('cancel');
                forceDigest();
              }
              delete scope.dialogMessage[guid];
              $(mask).fadeTo('slow', 0.0).remove();
              $(errorBox).remove();
            });
          });
        // Set height and width to mask to fill up the whole screen
        $(mask).css({
          width: maskWidth,
          height: '100vh',
        });
        $(mask).fadeTo('slow', 0.6);
        $(errorBox)
          .show()
          .animate(
            {
              height: '135px',
            },
            1000,
          )
          .delay(1000);
        return;
      }

      // Set height and width to mask to fill up the whole screen
      $(mask).css({
        width: maskWidth,
        height: '100vh',
      });

      $(mask).fadeTo('slow', 0.6);
      $(errorBox)
        .html(dialogMessage.message)
        .trigger('create')
        .show()
        .animate(
          {
            height: '135px',
          },
          1000,
        )
        .delay(hideDelay)
        .fadeTo('fast', 0.0, () => {
          $(errorBox).remove();
          delete scope.dialogMessage[guid];
          $(mask).fadeTo('slow', 0.0).remove();
          if (callback) {
            callback();
          }
        });
    });
  };

  return {
    restrict: 'E',
    link: linkFn,
  };
});
